import React, { useState } from 'react';
import Modal from 'olive-react-myoneui/lib/Modal';
import { globeBoldIcon, tickIcon } from '../../constants/icons';

const LanguageModal = () => {
  const [show, setShow] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState('English');

  const handleShow = () => {
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
  };

  const handleLanguageSelection = (language) => {
    setSelectedLanguage(language);
    handleClose();
  };

  const languageList = [
    'English',
    'Arabic',
    'Algerian',
    'Chinese',
    'French',
    'Philipino',
    'Greek',
    'Hindi',
    'Japanese',
    'Turkish',
    'Spanish',
    'Sindhi',
    'Somali',
    'Syrian'
  ];

  const sortedLanguageList = [selectedLanguage, ...languageList.filter((lang) => lang !== selectedLanguage)];

  return (
    <>
      <div className="mk-dropdown-lang-wrapper lang-modal-link" onClick={handleShow}>
        <div className="mk-dropdown-lang d-flex align-items-center justify-content-between">
          <span className="mk-dropdown-heading">{globeBoldIcon}Language</span>
          <span className="mk-lang-label">
            {selectedLanguage ? selectedLanguage : 'English'}
          </span>
        </div>
      </div>
      <Modal show={show} onHide={handleClose} centered className='language-modal-box' size="sm">
        <Modal.Body>
          <ul className="lang-modal-list">
            {sortedLanguageList.map((language) => (
              <li
                key={language}
                onClick={() => handleLanguageSelection(language)}
                className={selectedLanguage === language ? 'selected' : ''}
              >
                {language} {selectedLanguage === language && <span className="tick-icon">{tickIcon}</span>}
              </li>
            ))}
          </ul>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default LanguageModal;
